module.exports = __webpack_public_path__ + "static/media/5.4 Eisvogel nach.71909c68.jpg";